import Vue from 'vue'
import vueHeadful from 'vue-headful'
import Router from 'vue-router'
import Home from '@/components/HomePage'
import About from '@/components/AboutPage'
import Contact from '@/components/ContactPage'
import Project from '@/components/ProjectsPage'
import NotFound from '@/components/404NotFound'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

Vue.component('vue-headful', vueHeadful)

library.add(fas)
library.add(far)
library.add(fal)
library.add(fab)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/projects',
      name: 'Projects',
      component: Project
    },
    {
      path: '*',
      name: '404',
      component: NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js